import classNames from "classnames";
import React from "react";
import { GithubPicker } from "react-color";
import { config } from "../config";
import "./Colors.scss";

export const Colors = ({ onChange, disabled }: { onChange: (color: any) => void; disabled?: boolean }): JSX.Element => {
    const colors = config.default.colors || [
        "#FF6900",
        "#FCB900",
        "#008744",
        "#00D084",
        // "#8ED1FC",
        "#0057e7",
        "#ABB8C3",
        "#333333",
        "#EB144C",
        "#F78DA7",
        "#9900EF"
    ];

    const onColorChange = (color) => onChange(color);

    return (
        <div className={classNames("color-picker-container", { disabled })}>
            <GithubPicker width={288} triangle={"hide"} onChangeComplete={onColorChange} colors={colors} />
            {/* <TwitterPicker
                width={300}
                triangle={"hide"}
                // onChangeComplete={(color) => feature.set("COLOR", color.hex)}
                onChangeComplete={(color) => console.log("color", color.hex)}
                colors={colors}
            /> */}
        </div>
    );
};
